import { View, Text, ScrollView } from "react-native";
import React, { useEffect, useState } from "react";
import { s } from "react-native-size-matters";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { toast } from "react-toastify";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getUserProfile } from "../../../services/authAPI";
import { getLoginData, storeLoginData } from "../../../utility/AppStoreData";
import { AppScreens } from "../../Utility/AppScreens";
import { AppImages } from "../../../utility/AppImages";
import ChooseGameLikeSkeleton from "../../../Components/skeleton-components/ChooseGameLikeSkeleton";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import AvatarComponent from "../../../Components/choose-avatar-components/AvatarComponent";
import Separator from "../../../Components/Separator";
import { AvatarLookComponent } from "../../../Components/choose-avatar-components/AvatarLookComponent";
import { CommonButton } from "../../../common/CommonButton";
import Header from "./Common/Header";
import { Dimensions } from "react-native";
import {
  fetchAvatar,
  updateAvatarToProfile,
} from "../../../services/avatarAPI";
import { ShowLoader } from "../../../common/ShowLoader";
import ChangeAvatarSkeleton from "../../../Components/skeleton-components/ChangeAvatarSkeleton";
import { ScreenBGGradientView } from "../../../common/CommonView";
const ChangeAvatar = ({ route }) => {
  const routeParams = route.params;
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [filteredAvatars, setFilteredAvatars] = useState([]);
  const navigation = useNavigation();
  const [searchEvent, setSearchEvent] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showUpdateGamesLoader, setShowUpdateGamesLoader] = useState(false);
  const [myGames, setMyGames] = useState([]);
  const [selectedAvatarDetails, setSelectedAvatarDetails] = useState(null);
  const [selectedAvatarPart, setSelectedAvatarPart] = useState("full");
  const [selectedAvatarUrl, setSelectedAvatarUrl] = useState(
    "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
  );
  const [selectedAvatar, setSelectedAvatar] = useState("tiger");
  const [userProfileData, setUserProfileData] = useState(null);
  console.log("selectedAvatarDetails", selectedAvatarDetails);

  const screenHeight = Dimensions.get("window").height;
  const handleAvatarPartSelection = (url) => {
    setSelectedAvatarUrl(url);
  };
  const normalizedAvatars = filteredAvatars.reduce((acc, avatars) => {
    Object.values(avatars).forEach((avatar) => acc.push(avatar));
    return acc;
  }, []);
  useEffect(() => {
    if (userProfileData) {
      setSelectedAvatarUrl(userProfileData.profilePicture);
      setSelectedAvatar(userProfileData.avatarName);
      setSelectedAvatarPart(userProfileData.avatarPart);

      setSelectedAvatarDetails({
        full: userProfileData.profilePicture,
      });
    }
  }, [userProfileData]);
  const getAvatars = async () => {
    setShowLoader(true);

    try {
      const response = await fetchAvatar();

      if (response.statusCode === 200) {
        setFilteredAvatars(response.avatars);
      } else {
        toast.error(response.error);
      }
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      console.error("get games API Error:- ", error.message);
      toast.error(error.message);
    }
  };
  useEffect(() => {
    getLoginUserData();
    getAvatars();
  }, []);
  const updateAvatar = async () => {
    setShowLoader(true);
    try {
      const params = {
        username: userProfileData.userID,
        profilePic: selectedAvatarUrl,
        avatarName: selectedAvatar,
        avatarPart: selectedAvatarPart,
      };
      const response = await updateAvatarToProfile(params);
      if (response.statusCode === 200) {
        toast.success(response.body.message);
        if (routeParams.screen === "Profile") {
          navigateToScreen(navigation, AppScreens.MyProfileWebScreen);
        } else {
          navigateToScreen(navigation, AppScreens.SettingWebScreen);
        }
        // navigation.dispatch(StackActions.pop());
      } else {
        toast.error(response.body.error);
      }
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      console.error("get games API Error:- ", error.message);
      toast.error(error.message);
    }
  };
  const getLoginUserData = async () => {
    try {
      const data = await getLoginData();
      if (data != null) {
        await userProfileAPI(data.AccessToken);
      }
    } catch (error) {
      toast.error("Failed to fetch user data");
    }
  };
  const userProfileAPI = async (AccessToken?: string) => {
    setShowLoader(true);

    try {
      const data = await getUserProfile(AccessToken);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      setShowLoader(false);

      if (data.statusCode === 200) {
        setUserProfileData(responseBody);
      } else if (data.statusCode == 400) {
        toast.error("Bad Request");
      } else if (data.statusCode > 400 && data.statusCode < 420) {
        toast.error("Unauthorized");
      } else if (data.statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };
  return (
    <View style={{ flex: 1 }}>
      <ScreenBGGradientView />
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />
      <View style={styles.container}>
        {showLoader ? (
          <ChangeAvatarSkeleton />
        ) : (
          <View
            style={{
              flex: 1,
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_20
                  : AppFontStyle.BOLD_ANYBODY_32,
                {
                  color: AppColors.white,
                },
              ]}
            >
              Change avatar
            </Text>

            <View>
              <View style={styles.headerSection}>
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_16
                      : AppFontStyle.BOLD_ANYBODY_20,
                    {
                      color: AppColors.white,
                    },
                  ]}
                >
                  Avatar Look
                </Text>
                <View style={styles.buttonGroup}>
                  <CommonButton
                    title="Save"
                    onTap={() => updateAvatar()}
                    buttonStyle={styles.saveButton}
                    textStyle={AppFontStyle.BOLD_ANYBODY_12}
                  />
                  <CommonButton
                    title="Back"
                    onTap={() => {
                      if (routeParams.screen === "Profile") {
                        navigateToScreen(navigation, AppScreens.MyProfileWebScreen);
                      } else {
                        navigateToScreen(navigation, AppScreens.SettingWebScreen);
                      }
                    }}
                    buttonStyle={styles.backButton}
                    textStyle={AppFontStyle.BOLD_ANYBODY_12}
                  />
                </View>
              </View>

              <AvatarLookComponent
                selectedAvatarDetails={selectedAvatarDetails}
                selectedAvatarPart={selectedAvatarPart}
                handleAvatarPartSelection={handleAvatarPartSelection}
                setSelectedAvatarPart={setSelectedAvatarPart}
                changeAvatar={true}
              />
              <Separator
                height={"1px"}
                color={AppColors.white}
                width={"100%"}
                marginBottom={10}
              />
              <ScrollView
                contentContainerStyle={[
                  styles.gridContainer,
                  {
                    height:
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                        ? screenHeight - 375
                        : 340,
                  },
                ]}
                style={styles.scrollView}
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
              >
                {normalizedAvatars.map((avatar, index) => (
                  <AvatarComponent
                    key={index}
                    avatar={avatar}
                    isSelected={selectedAvatarDetails?.full === avatar.full}
                    onSelectionChange={() => {
                      setSelectedAvatarDetails(avatar); // Store the selected avatar's details
                      setSelectedAvatarUrl(avatar.full);
                    }}
                    styles={styles}
                  />
                ))}
              </ScrollView>
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

export default ChangeAvatar;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      flexDirection: "row",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    headerSection: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 20,
      marginTop: 10,
    },
    buttonGroup: {
      flexDirection: "row",
      gap: 15,
      alignItems: "center",
    },
    saveButton: {
      paddingVertical: 12,
      paddingHorizontal: 30,
      backgroundColor: "#DC2626",
      borderRadius: 10,
      shadowOpacity: 0,
      height: 45,
    },
    backButton: {
      paddingVertical: 12,
      paddingHorizontal: 30,
      backgroundColor: "#4B5563",
      borderRadius: 10,
      shadowOpacity: 0,
      height: 45,
    },
    gridContainer: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      paddingHorizontal: 5,
      paddingVertical: 10,
      gap: 15,
    },
    scrollView: {
      height: "100%",
    },
    loaderContainer: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
      zIndex: 10, // Ensure the loader is on top
    },
    shodowBottom: {
      height: "40%",
      width: "30%",
      position: "absolute",
      resizeMode: "stretch",
      bottom: 0,
    },
    shodowTopRight: {
      width: 820,
      height: 546,
      position: "absolute",
      resizeMode: "stretch",
      top: 0,
      right: 0,
      flexShrink: 0,
      // transform: [{ rotate: "6.171deg" }],
    },
    serachBtn: {
      width: 24,
      height: 24,
    },
    item: {
      flex: 1,
      //   height: 168,
      borderRadius: s(10),
      borderWidth: s(2),
      borderColor: AppColors.white,
      shadowColor: AppColors.black,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.2,
      shadowRadius: s(2),
      elevation: s(2),
      gap: s(14),
    },
    searchTextStyle: {
      width: 459,
      height: 35,
      alignItems: "center",
      borderWidth: 0,
    },
    columnWrapperStyle: {
      // height: 96
      overflow: "scroll",
      gap: s(3),
      display: "flex",
    },
    suggestionBox: {
      backgroundColor: AppColors.appBlueColor_3A5175,
      borderRadius: 10,
      position: "absolute",
      top: 45,
      zIndex: 1000,
      width: 459,
      maxHeight: 200,
    },
    suggestionItem: {
      padding: 10,
      borderBottomWidth: 1,
      borderBottomColor: AppColors.white + "33",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      headerSection: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 20,
        marginTop: 10,
      },
      buttonGroup: {
        flexDirection: "row",
        gap: 12,
      },
      saveButton: {
        paddingVertical: 12,
        paddingHorizontal: 28,
        height: 45,
      },
      backButton: {
        paddingVertical: 12,
        paddingHorizontal: 28,
        height: 45,
      },
      shodowBottom: {
        height: "40%",
        width: "30%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      columnWrapperStyle: {
        // gap: s(150),
        // // width: "100%",
        overflow: "scroll",
        gap: s(10),
      },
    },
    [DEVICE_SIZES.MD]: {
      headerSection: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 18,
        marginTop: 10,
      },
      buttonGroup: {
        flexDirection: "row",
        gap: 10,
      },
      saveButton: {
        paddingVertical: 10,
        paddingHorizontal: 25,
        height: 42,
      },
      backButton: {
        paddingVertical: 10,
        paddingHorizontal: 25,
        height: 42,
      },
      shodowBottom: {
        height: "40%",
        width: "30%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      columnWrapperStyle: {
        // gap: s(150),
        // // width: "100%",
        overflow: "scroll",
        gap: s(8),
      },
    },
    [DEVICE_SIZES.SM]: {
      headerSection: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 15,
        marginTop: 10,
      },
      buttonGroup: {
        flexDirection: "row",
        gap: 8,
      },
      saveButton: {
        paddingVertical: 8,
        paddingHorizontal: 20,
        height: 38,
      },
      backButton: {
        paddingVertical: 8,
        paddingHorizontal: 20,
        height: 38,
      },
      gridContainer: {
        justifyContent: "space-between",
        gap: 8,
      },
      shodowBottom: {
        height: "40%",
        width: "30%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: "90%",
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      columnWrapperStyle: {
        // gap: s(150),
        // // width: "100%",
        overflow: "scroll",
        gap: s(6),
      },
      suggestionBox: {
        width: "90%",
      },
    },
    [DEVICE_SIZES.XS]: {
      headerSection: {
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        marginBottom: 15,
        marginTop: 10,
        gap: 12,
      },
      buttonGroup: {
        flexDirection: "row",
        gap: 8,
        width: "100%",
        justifyContent: "flex-end",
      },
      saveButton: {
        paddingVertical: 8,
        paddingHorizontal: 18,
        height: 36,
        flex: 1,
      },
      backButton: {
        paddingVertical: 8,
        paddingHorizontal: 18,
        height: 36,
        flex: 1,
      },
      gridContainer: {
        justifyContent: "space-between",
        gap: 8,
        paddingHorizontal: 8,
      },
      shodowBottom: {
        height: "25%",
        width: "50%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: "90%",
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      columnWrapperStyle: {
        gap: s(4),
        // width: "100%",
        overflow: "scroll",
      },
      shodowTopRight: {
        width: 545,
        height: 283,
      },
      suggestionBox: {
        width: "90%",
      },
    },
  }
);
